import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useLocation, useNavigate } from 'react-router'
import { useTranslate } from '@repo/unicity'
import type { MenuItemConfig } from './menu-items'
import { TEXT_INACTIVE, lockedFont } from './constants'

interface MenuListProps {
    items: MenuItemConfig[]
    isMobile: boolean
}

const MenuList = ({ items, isMobile }: MenuListProps) => {
    const location = useLocation()
    const navigate = useNavigate()
    const { translate } = useTranslate()

    return (
        <Stack sx={{ mt: isMobile ? '0px' : '10px', mb: 1 }} data-testid="menu-list-stack">
            {items.map(item => {
                const isActive = location.pathname.startsWith(item.path)
                return (
                    <Box
                        key={item.key}
                        onClick={() => !isActive && navigate(item.path)}
                        sx={{
                            cursor: isActive ? 'default' : 'pointer',
                            height: '50px',
                            display: 'flex',
                            alignItems: 'center',
                            mt: isMobile ? '20px' : '18px',
                            px: '40px',
                            transition: 'background-color 120ms ease'
                        }}
                        data-testid="menu-list-box-typography">
                        <Typography
                            sx={{
                                ...lockedFont('24px', '36px'),
                                fontFamily: 'var(--font-poppins)',
                                fontWeight: isActive ? 600 : 300,
                                color: isActive ? '#FFFFFF' : TEXT_INACTIVE
                            }}
                            data-testid="menu-list-typography">
                            {translate(item.labelKey)}
                        </Typography>
                    </Box>
                )
            })}
        </Stack>
    )
}

export default MenuList
